import React, { useEffect, useState, useRef, memo } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Header from "./Header";
import Body from "./Body";
import Loader from "App/common/ui/Loader";
import { fetchActivityLogsStart } from "store/actions";
import { epocToDate } from "utils";
import Notify from "App/common/ui/Notify";

function Activities(props) {
  let startDate = null;
  const endDate = new Date().getTime() / 1000;
  const headerRef = useRef(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const [notification, setNotification] = useState({
    show: false,
    params: null
  });

  const date = new Date();
  date.setDate(date.getDate() - 6);
  startDate = date.getTime() / 1000;

  const showNotification = params =>
    setNotification({ show: true, params: params });

  const closeNotification = () => setNotification({ show: false });

  useEffect(() => {
    if (props.notification.webActivity)
      showNotification(props.notification.webActivity);
    else closeNotification();
  }, [props.notification]);

  const [dates, setDates] = useState({
    startDate: {
      key: "startDate",
      title: "From Date",
      value: startDate
    },
    endDate: {
      key: "endDate",
      title: "End Date",
      value: endDate,
      currentDate: endDate
    }
  });

  const [enterDates, setEnterDates] = useState({
    startDate: {
      key: "startDate",
      title: "From Date",
      value: startDate
    },
    endDate: {
      key: "endDate",
      title: "End Date",
      value: endDate,
      currentDate: endDate
    }
  });

  function dateChangeHandler(type, value) {
    let update = true;
    const parts = value.split("-");
    const date = new Date(parts[2], parts[0] - 1, parts[1]).getTime() / 1000;

    if (
      (type === "startDate" && value > dates["endDate"].value) ||
      (type === "endDate" && value < dates["startDate"].value)
      // (type === "endDate" &&
      //   (date < dates["startDate"].value ||
      //     date > dates["endDate"].currentDate))
    )
      update = false;

    if (update) {
      setDates(prevState => ({
        ...prevState,
        [type]: { ...prevState[type], value: date }
      }));
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function formSubmitHandler() {
    props.fetchActivityLogsStart(
      epocToDate(dates.startDate.value, "yyyy-MM-dd"),
      epocToDate(dates.endDate.value, "yyyy-MM-dd")
    );
    setEnterDates(dates);
  }

  function resetDatesHandler() {
    setDates(prevState => ({
      ...prevState,
      startDate: { ...prevState["startDate"], value: startDate },
      endDate: { ...prevState["endDate"], value: endDate }
    }));
    setEnterDates(prevState => ({
      ...prevState,
      startDate: { ...prevState["startDate"], value: startDate },
      endDate: { ...prevState["endDate"], value: endDate }
    }));

    props.fetchActivityLogsStart(
      epocToDate(startDate, "yyyy-MM-dd"),
      epocToDate(endDate, "yyyy-MM-dd")
    );
  }

  useEffect(() => {
    formSubmitHandler();
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onScroll() {
    if (!headerRef.current) return;
    if (headerRef.current.getBoundingClientRect().bottom <= 60) {
      setShowScrollTop(true);
    } else {
      setShowScrollTop(false);
    }
  }

  function goToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  let content = null;
  if (props.loading) {
    content = <Loader main={true} />;
  } else {
    content = (
      <div className="main_container_inner">
        <div className="main_header_title">
          <p>
            Web Activity Logs{" "}
            <span> (View a list of your recent web-based activities)</span>
          </p>
        </div>
        {notification.show && (
          <Notify
            notify={notification}
            refresh={false}
            closeNotify={closeNotification}
            commonNotify={true}
          />
        )}

        {showScrollTop && (
          <div className="scrolltop" id="scrolltopfixed" onClick={goToTop}>
            <div className="scrolltop_inner" />
          </div>
        )}

        <Header
          dates={dates}
          dateChangeHandler={dateChangeHandler}
          formSubmitHandler={formSubmitHandler}
          resetDatesHandler={resetDatesHandler}
          headerRef={headerRef}
        />

        <Body
          dates={dates}
          showScrollTop={showScrollTop}
          enterDates={enterDates}
        />
      </div>
    );
  }

  return content;
}

function mapStateToProps(state) {
  return {
    loading: state.activities.loading,
    notification: state.common.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchActivityLogsStart }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Activities);
